import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa'
import "./footer.css"
function Footer() {
  return (
    <footer>
        <div  className="footer-section">
      <div className="container">
        <div className="row footer-content">
          {/* Left Section */}
          <div className="col-md-4 footer-column">
            <h5 className="footer-heading">At <span className="bold-text">Enteeon.</span></h5>
            <p className="footer-text">
              We create the future's most important ingredient, using the black soldier fly larvae as a unique source of protein for food and feed.
            </p>
          </div>

          {/* Middle Section */}
          <div className="col-md-4 footer-column footer-links">
            <h5 className="footer-heading">Quick Links.</h5>
            <ul className="footer-list">
              <li><a href=".">Home</a></li>
              <li><a href=".">The Problem & Impact</a></li>
              <li><a href=".">Products</a></li>
              <li><a href=".">Sustainability & Science</a></li>
              <li><a href=".">Contact</a></li>
              <li><Link to="/admin/login">Admin Login</Link></li>
            </ul>
          </div>

          {/* Right Section */}
          <div className="col-md-4 footer-column">
            <h5 className="footer-heading">Contact.</h5>
            <p className="footer-text">
              Email: enteeonhere@gmail.com <br />
              Phone: +91 88073-41866  <br />
              Address: VelammaValasu, Sankari, Salem, Tamil Nadu
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/people/Enteeon-Organics" target="_blank" rel="noopener noreferrer">
                <FaFacebook size={24} />
              </a>
              <a href="https://www.linkedin.com/company/enteeon-organics" target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={24} />
              </a>
              <a href="https://www.instagram.com/enteeon_organics/" target="_blank" rel="noopener noreferrer">
                <FaInstagram size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-bottom">
        Copyright © Enteeon Organics Pvt Ltd., 2025
      </div>
    </footer>
  )
}

export default Footer